export default "__VITE_ASSET__BExw_iJ3__"